import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

@Directive({
    selector: '[appWeightValidation]',
    providers: [{ provide: NG_VALIDATORS, useExisting: WeightValidationDirective, multi: true }],
    standalone: false
})
export class WeightValidationDirective implements Validator {

    @Input() maxWeight: number;
    private topLimitWeight = 99999;

    validate(c: AbstractControl): { [key: string]: any } {
        const maxWeight = this.maxWeight || this.topLimitWeight;
        const weight: number = +c.value;
        if (weight) {
            if ((weight <= 0 || weight > maxWeight)) {
                return { 'weight': { value: `Invalid weight. Must be between 1-${maxWeight}` } };
            }
        }
        return null;
    }

    registerOnValidatorChange?(fn: () => void): void { }
}

